import React, { useEffect, useState } from 'react'
import "./CalendarPage.css"
import axios from 'axios';
import { api } from '../../settings/env';

export default function CalendarPage() {
    const months = {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre"
    }
    const [monthsSelected, setMonthsSelected] = useState(1);
    const [yearSelected, setYearSelected] = useState(2025);
    const [mappingDaySelected, setMappingDaySelected] = useState(1);
    const [quantityDays, setQuantityDays] = useState(1);
    const [daySelected, setDaySelected] = useState(false);
    const [step, setStep] = useState(1);
    const [citas, setCitas] = useState(false);
    const [times, setTimes] = useState(false);

    function convertirHoraMilitarACivil(horaMilitar) {
        // Dividir la hora en horas y minutos
        const [horas, minutos] = horaMilitar.split(':').map(Number);

        // Determinar AM o PM
        const ampm = horas >= 12 ? 'PM' : 'AM';

        // Convertir horas a formato de 12 horas
        let horasCivil = horas % 12;
        horasCivil = horasCivil === 0 ? 12 : horasCivil; // 12 AM y 12 PM

        // Formatear la hora civil
        const horaCivil = `${horasCivil}:${String(minutos).padStart(2, '0')} ${ampm}`;

        return horaCivil;
    }

    const renderDays = (datetime) => {

        if (datetime) {
            // Obtener el dia
            const dayOfWeek = datetime.getDay()
            setMappingDaySelected(parseInt(dayOfWeek));

            // Obtener el mes
            const month = datetime.getMonth();
            setMonthsSelected(parseInt(month) + 1);

            console.log("Entro en modo manual")
            console.log(datetime, dayOfWeek)
        } else {
            console.log("Modo default")
            // Año-Mes-Dia
            const dateString = `${yearSelected}-${monthsSelected}-01`;
            const date = new Date(dateString);
            const dayOfWeek = date.getDay()
            setMappingDaySelected(parseInt(dayOfWeek));
            console.log(dateString, date, dayOfWeek);
            setQuantityDays(getDaysInMonth(yearSelected, monthsSelected - 1))
        }
    }

    const nextMonth = () => {
        if (monthsSelected === 12) {
            setMonthsSelected(1);
            setYearSelected((prev) => prev + 1);
        } else {
            setMonthsSelected(monthsSelected + 1);
        }
    }

    const prevMonth = () => {
        if (monthsSelected === 1) {
            setMonthsSelected(12);
            setYearSelected((prev) => prev - 1);
        } else {
            setMonthsSelected(monthsSelected - 1);
        }
    }

    const handleSelectDay = (day) => {

        const id = localStorage.getItem("vitaly_userid");

        const data = {
            "day": day,
            "month": monthsSelected,
            "year": yearSelected
        }

        console.log("Query", data);

        axios.post(`${api}/appoinments/${id}`, data)
            .then(response => {
                console.log("Cita registrada", response.data);
                setCitas(response.data);

                response.data.map(el => {

                    if (el.status != "Confirmado") {
                        return
                    }

                    const div = document.getElementById(el.time)

                    console.log("Soy ", el.time, div)

                    if (div) {
                        div.innerText = el.full_name;
                        div.style.background = "#7183ffb8"
                    }
                })
            })
            .catch(error => {
                console.log("Error al registrar la cita", error);
            });


        setDaySelected(day);
        setStep(2);
    }

    function getDaysInMonth(year, month) {
        // El mes se especifica en base 0 (0 = enero, 11 = diciembre)
        return new Date(year, month + 1, 0).getDate();
    }

    // 
    const elements = Array.from({ length: quantityDays - 1 }, (_, index) => (
        <div className='cita-card' key={index} onClick={() => handleSelectDay(index + 2)}>
            <div>{index + 2}</div>

            <p>
                5 citas agendadas <br />
                0 cupos
            </p>
        </div>
    ));

    const handleTime = () => {
        console.log()
    }

    const getTimes = () => {
        const userid = localStorage.getItem("vitaly_userid");

        axios.get(`${api}/register/professional-info/${userid}`)
            .then(response => {
                console.log("Professional info", response.data.data);

                setTimes(response.data.data.times);
                console.log(response.data.data.times);
            })
            .catch(error => console.error(error));



    }

    //
    useEffect(() => {
        // Obtener times
        getTimes();

        // Obtener fecha actual
        const currentDate = new Date();
        renderDays(currentDate);

        // Obtener dias del mes actual
        setQuantityDays(getDaysInMonth(currentDate.getFullYear(), currentDate.getMonth()))
    }, [])

    useEffect(() => {
        renderDays()
    }, [monthsSelected])

    return (
        <div className="page-admin" 
            style={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: "0",
                width: "100%",
                background: "#f8f9fa"
            }}
        >
            

            {
                step == 1 &&
                <div
                    style={{
                        background: "#fff",
                        padding: "20px",
                        borderRadius: "13px"
                    }}
                >
                    <div className="control-mount py-4">

                        <h4>Citas agendadas</h4>

                        <div style={{display: "flex"}}>
                            <div className="prev" onClick={prevMonth}>
                                <img src="/assets/icons/chevron-left.svg" width={"70%"} alt="" />
                            </div>
                            <h4>{months[monthsSelected]} {yearSelected}</h4>
                            <div className="next" onClick={nextMonth}>
                                <img src="/assets/icons/chevron-right.svg" width={"70%"} alt="" />
                            </div>
                        </div>

                    </div>

                    <div className="citas">
                        <div className='header'>
                            <div>Domingo</div>
                            <div>Lunes</div>
                            <div>Martes</div>
                            <div>Miercoles</div>
                            <div>Jueves</div>
                            <div>Viernes</div>
                            <div>Sabado</div>
                        </div>

                        <div className="days">

                            <div className='cita-card'
                                style={{ gridColumnStart: `${mappingDaySelected + 1}` }}
                                onClick={() => handleSelectDay(1)}
                            >
                                <div>1</div>

                                <p>
                                    5 citas agendadas <br />
                                    0 cupos
                                </p>

                            </div>



                            {elements}


                        </div>
                    </div>
                </div>
            }

            {
                step == 2 && <div>

                    {
                        citas == false && citas.length != 0 && <p>Cargando...</p>
                    }

                    {
                        citas && citas.length == 0 && <p>No hay registros</p>
                    }

                    {
                        times && times.map((item, index) => (
                            <ul className='timer my-4'>
                                <li onClick={() => handleTime("9:00pm")}>
                                    {convertirHoraMilitarACivil(item)} <br />

                                </li>

                                <div style={{ display: 'flex', justifyContent: "center", alignItems: "center" }} id={item}>
                                    Disponible
                                </div>
                            </ul>
                        ))
                    }


                    <div className="btn-group mt-4" onClick={() => setStep(1)}>
                        <button className="btn btn-primary">
                            Regresar
                        </button>
                    </div>
                </div>
            }
        </div>
    )
}
